import { ThemeDetails } from '@yandex-int/k-common/typings';
import { H3, MarkdownExtXContent, Spin } from 'platform-components';
import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import React from 'react';
import { connect } from 'react-redux';

import * as themeSelectors from 'store/themes/selectors';

import SectionPageHeader from '../__header/section-page__header';
import { ReduxTeacherStore } from '../../../typings';
import SectionMenu from '../../library.section-menu/section-menu';
import { getThemeDetails } from '../../library.store/selectors';

import './section-page__content.scss';

interface StoreProps {
    themeDetails: ThemeDetails | null;
    shouldShowChildThemes: boolean;
}

interface HOCProps extends WithRouterPathProps {}

interface Props extends HOCProps, StoreProps {}

export const SectionPageContent = ({ themeDetails, shouldShowChildThemes }: Props) => {
    if (!themeDetails) {
        return <Spin center />;
    }

    const { description, name } = themeDetails;

    return (
        <React.Fragment>
            <SectionPageHeader
                description={description}
                header={
                    <H3>
                        <MarkdownExtXContent>{name}</MarkdownExtXContent>
                    </H3>
                }
            />
            {shouldShowChildThemes && (
                <div className="section-page__section-menu">
                    <SectionMenu />
                </div>
            )}
        </React.Fragment>
    );
};

const mapStateToProps = (storeState: ReduxTeacherStore, { match: { params } }: HOCProps): StoreProps => {
    const themeId = Number(params.themeId);

    return {
        themeDetails: getThemeDetails(storeState, { themeId }),
        shouldShowChildThemes: !themeSelectors.getShouldHideChildThemes(storeState, {
            subject: params.subject,
            themeId,
            grade: null,
        }),
    };
};

const component = withRouterPath(connect(mapStateToProps)(SectionPageContent));

component.displayName = 'SectionPageContent';

export default component;
